/**
 * Composable pour gérer l'initialisation de useQuoteDetailPage
 */
export function useQuoteDetailPageInit(
  loadFormationsData,
  loadCommercials,
  loadQuote,
  loadComments,
  loadHistory,
  loadDuplicates
) {
  const initialize = async () => {
    await loadFormationsData()
    await loadCommercials()
    await loadQuote(async () => {
      await loadComments()
      loadHistory().catch(err => {
        console.warn('Could not load history:', err)
      })
      loadDuplicates().catch(err => {
        console.warn('Could not load duplicates:', err)
      })
    })
  }

  return {
    initialize
  }
}
